import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import OCRScopingJobBulkActionViewModel from '../../SidePanel/OCRScopingJobBulkActionViewModel'

/**
 * Modal to confirm the bulk submission of scoping jobs.
 */
export default class OCRConfirmBulkSubmitModalViewModel extends ModalViewModel {
  constructor(
    public readonly ocrScopingJobBulkActionViewModel: OCRScopingJobBulkActionViewModel,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  confirm = async () => {
    this.close()
    await this.ocrScopingJobBulkActionViewModel.bulkSubmit()
  }
}
